import { render } from "./disclamerPage.vue?vue&type=template&id=eedcc89a"
import script from "./disclamerPage.vue?vue&type=script&lang=js"
export * from "./disclamerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__